<template>
  <div class="switcher">
    <button
      :class="{ active: monthly }"
      @click="(monthly = true), switchMonthly()"
    >
      Monthly
    </button>
    <button
      :class="{ active: !monthly }"
      @click="(monthly = false), switchMonthly()"
    >
      Anually
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      monthly: false,
    };
  },

  methods: {
    switchMonthly() {
      this.$emit("switchMonthly", this.monthly);
    },
  },
};
</script>

<style lang="scss">
.switcher {
  display: flex;
  width: 208px;
  border-radius: 16px;
  background-color: #f9dbcc;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 96px;
  align-items: stretch;
  padding: 8px;

  @media all and (max-width: 767px) {
    width: 100%;
    margin-bottom: 64px;
  }

  button {
    width: 96px;
    height: 48px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fc5a12;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    font-style: normal;
    letter-spacing: normal;
    line-height: 24px;
    text-align: center;
    background-color: transparent;
    transition: background-color 180ms, color 180ms;

    @media all and (max-width: 767px) {
      width: auto;
      flex: 1 1 auto;
    }

    &.active,
    &:hover {
      background-color: #fc5a12;
      color: #fff;
      transition: background-color 180ms, color 180ms;
    }
  }
}
</style>